<template>
  <div class="detail">
    <div class="detail-banner" :style="{ background: caseItem ? (caseItem.headerBg || '#2444cb') : '#2444cb' }">
      <div class="container">
        <h1 v-if="caseItem">{{ caseItem.title }}</h1>
        <div class="sub" v-if="caseItem">
          <span class="tag" style="background:rgba(255,255,255,.25);color:#fff">{{ caseItem.tagText }}</span>
        </div>
      </div>
    </div>
    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>
        <div class="detail-content" v-if="caseItem">
          <section class="case-block">
            <h3 class="block-title">案例概述</h3>
            <p>{{ caseItem.content }}</p>
          </section>

          <section class="case-block" v-if="caseItem.bgContent">
            <h3 class="block-title">企业基本情况</h3>
            <p>{{ caseItem.bgContent }}</p>
          </section>

          <section
            class="case-block"
            v-if="caseItem.svcIntro || (caseItem.services && caseItem.services.length)"
          >
            <h3 class="block-title">服务举措</h3>
            <p v-if="caseItem.svcIntro">{{ caseItem.svcIntro }}</p>
            <ul class="svc-list" v-if="caseItem.services && caseItem.services.length">
              <li v-for="(s, i) in caseItem.services" :key="'s' + i">{{ s }}</li>
            </ul>
          </section>

          <section class="case-block" v-if="caseItem.results && caseItem.results.length">
            <h3 class="block-title">成效</h3>
            <ul class="svc-list">
              <li v-for="(r, i) in caseItem.results" :key="'r' + i">{{ r }}</li>
            </ul>
          </section>

        </div>
        <div class="detail-content" v-else-if="!loading">未找到该案例。</div>
        <div class="detail-content" v-else>加载中…</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCases } from '../api/home'

export default {
  name: 'CaseDetail',
  props: ['id'],
  data () {
    return {
      caseItem: null,
      loading: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const list = await fetchCases()
        this.caseItem = list.find(c => String(c.id) === String(this.id)) || null
      } catch (e) {
        this.caseItem = null
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/* 详情内容容器改为透明，板块各自成卡片 */
.detail-content {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}
/* 每个标题板块单独成区域卡片 */
.case-block {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 22px 24px;
  margin-bottom: 18px;
  box-shadow: 0 2px 12px rgba(20, 40, 90, 0.05);
}
.case-block:last-of-type {
  margin-bottom: 0;
}
/* 标题：前面加竖线装饰 */
.block-title {
  position: relative;
  padding-left: 14px;
  font-size: 18px;
  font-weight: 800;
  color: var(--text-main);
  margin: 0 0 14px;
}
.block-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 18px;
  background: var(--primary);
  border-radius: 3px;
}
.case-block p {
  margin: 0;
  line-height: 1.9;
  font-size: 15px;
  color: var(--text-sub);
}
.svc-list {
  margin: 0;
  padding-left: 20px;
  color: #33415c;
  line-height: 1.9;
}
/* 服务举措内：简介段落与清单之间留出间距 */
.case-block p + .svc-list {
  margin-top: 12px;
}
</style>
